
angular.module('cesium.map.services', [
    // Services
    'cesium.map.wot.services',
    'cesium.map.registry.services',
    'cesium.map.utils.services'
  ])
;
